/* ============================================
   DEAN SUPPLY — ROTATING ANNOUNCEMENTS
   rotating-announcements.js
   
   Self-contained script that transforms the
   existing Expanse toolbar into a rotating
   announcement bar with fade transitions,
   dot navigation, and persistent phone number.
   
   INSTALL:
   1. Upload to Assets
   2. Add before </body> in theme.liquid:
      <script src="{{ 'rotating-announcements.js' | asset_url }}" defer></script>
   ============================================ */

(function() {
  'use strict';

  // ============================================
  // CONFIG — Edit your messages here
  // ============================================
  var MESSAGES = [
    {
      text: 'Family-Owned in Cleveland Since 1950 — Real People, Real Support',
      link: '/pages/about-us',
      cta: null
    },
    {
      text: 'Trusted by 10,000+ Restaurants, Hotels & Caterers Nationwide',
      link: null,
      cta: null
    },
    {
      text: 'Try Before You Buy — Rent-to-Own Available on Equipment',
      link: '/pages/restaurant-equipment-financing-silverchef',
      cta: 'Learn More'
    },
    {
      text: 'Fast Shipping & Free Local Delivery Available',
      link: '/pages/local-truck-delivery',
      cta: null
    }
  ];

  var PHONE = '216-325-0994';
  var PHONE_HREF = 'tel:+12163250994';
  var INTERVAL = 4000;       // ms between rotations
  var FADE_DURATION = 300;   // ms for fade transition

  // ============================================
  // INIT — Wait for DOM, then transform toolbar
  // ============================================
  function init() {
    var toolbar = document.querySelector('.toolbar');
    if (!toolbar) return;

    // Find the inner content area
    var content = toolbar.querySelector('.toolbar__content') ||
                  toolbar.querySelector('.announcement-bar') ||
                  toolbar.querySelector('.page-width');
    if (!content) return;

    // Build the rotating bar HTML
    var barHTML = buildBarHTML();
    
    // Replace content
    content.innerHTML = barHTML;
    content.classList.add('ds-announcements');

    // Hide sibling elements (currency selector, etc.) so phone has room
    var siblings = content.parentElement ? content.parentElement.children : [];
    for (var s = 0; s < siblings.length; s++) {
      if (siblings[s] !== content) {
        siblings[s].style.display = 'none';
      }
    }

    // Start rotation
    startRotation();
  }

  // ============================================
  // BUILD HTML
  // ============================================
  function buildBarHTML() {
    var html = '';

    // Messages container
    html += '<div class="ds-announce__messages">';
    for (var i = 0; i < MESSAGES.length; i++) {
      var msg = MESSAGES[i];
      var activeClass = i === 0 ? ' ds-announce__msg--active' : '';
      html += '<div class="ds-announce__msg' + activeClass + '" data-index="' + i + '">';
      
      if (msg.link) {
        html += '<a href="' + msg.link + '" class="ds-announce__link">';
      }
      
      html += '<span class="ds-announce__text">' + msg.text + '</span>';
      
      if (msg.cta) {
        html += '<span class="ds-announce__cta">' + msg.cta + ' →</span>';
      }
      
      if (msg.link) {
        html += '</a>';
      }
      
      html += '</div>';
    }
    html += '</div>';

    // Dot navigation
    html += '<div class="ds-announce__dots">';
    for (var j = 0; j < MESSAGES.length; j++) {
      var dotActive = j === 0 ? ' ds-announce__dot--active' : '';
      html += '<button class="ds-announce__dot' + dotActive + '" data-index="' + j + '" aria-label="Announcement ' + (j + 1) + '"></button>';
    }
    html += '</div>';

    // Phone number (persistent)
    html += '<a href="' + PHONE_HREF + '" class="ds-announce__phone">';
    html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
    html += '<span>' + PHONE + '</span>';
    html += '</a>';

    return html;
  }

  // ============================================
  // ROTATION ENGINE
  // ============================================
  var currentIndex = 0;
  var timer = null;
  var isTransitioning = false;

  function startRotation() {
    timer = setInterval(function() {
      goTo((currentIndex + 1) % MESSAGES.length);
    }, INTERVAL);

    // Dot click handlers
    var dots = document.querySelectorAll('.ds-announce__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', function(e) {
        e.preventDefault();
        var idx = parseInt(this.getAttribute('data-index'), 10);
        if (idx !== currentIndex) {
          clearInterval(timer);
          goTo(idx);
          timer = setInterval(function() {
            goTo((currentIndex + 1) % MESSAGES.length);
          }, INTERVAL);
        }
      });
    }

    // Pause on hover
    var container = document.querySelector('.ds-announce__messages');
    if (container) {
      container.addEventListener('mouseenter', function() {
        clearInterval(timer);
      });
      container.addEventListener('mouseleave', function() {
        timer = setInterval(function() {
          goTo((currentIndex + 1) % MESSAGES.length);
        }, INTERVAL);
      });
    }
  }

  function goTo(index) {
    if (isTransitioning) return;
    isTransitioning = true;

    var msgs = document.querySelectorAll('.ds-announce__msg');
    var dots = document.querySelectorAll('.ds-announce__dot');

    // Fade out current
    if (msgs[currentIndex]) {
      msgs[currentIndex].classList.remove('ds-announce__msg--active');
    }

    // After fade, show new
    setTimeout(function() {
      currentIndex = index;
      if (msgs[currentIndex]) {
        msgs[currentIndex].classList.add('ds-announce__msg--active');
      }

      // Update dots
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('ds-announce__dot--active', i === currentIndex);
      }

      isTransitioning = false;
    }, FADE_DURATION);
  }

  // ============================================
  // LAUNCH
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
